import { makeContextModule } from '@cian/react-utils';
import { TPosition } from '../../../types/messageContextMenu';

export type ChatMessageMenuState = {
  x: number;
  y: number;
  chatId: string;
  messageId: string;
};

export type TChatMessageMenuProps = {
  chatMessageMenuState: ChatMessageMenuState | null;
  showChatMessageMenu: (chatId: string, messageId: string, position?: TPosition) => void;
  hideChatMessageMenu: () => void;
};

export const { Context: ChatMessageMenuContext, useContext: useChatMessageMenu } =
  makeContextModule<TChatMessageMenuProps>({
    contextName: 'ChatMessageMenuContext',
  });
